import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { AuthService } from '../../core/auth/auth.service';
import { TempStateService } from '../../core/navigation/tempState.service';
import { BaseHttpResponse } from 'src/app/models/base-http-response';
import { ApiService } from 'src/app/services/http/api.service';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { MessageService } from '@progress/kendo-angular-l10n';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html'
})
export class RecoverPasswordComponent implements OnInit {
  formGroup: FormGroup;
  isLoadingResults: boolean = false;
  isLoadingError: boolean = false;
  hideError: boolean = false;
  txtValue: string = '';
  public errorMessage: string = '';
  returnUrl: string = '';
  public guid: string = '';
  isPasswordVisible: boolean = false;
  isPasswordRewriteVisible: boolean = false;
  public customMsgService: CustomMessagesService;

  constructor(
    private auth: AuthService,
    private router: Router,
    public msgService: MessageService,
    private stateService: TempStateService, private api: ApiService, private formBuilder: FormBuilder
  ) {
    this.customMsgService = this.msgService as CustomMessagesService;
    this.formGroup = this.formBuilder.group({
      email: [null, [Validators.required, Validators.email]],
    });
  }
  public onChanges() {
    if (this.formGroup.controls['email'].value == '')
      this.isLoadingError = false;
  }

  ngOnInit(): void {
    this.formGroup = this.formBuilder.group({
      email: [null, [Validators.required, Validators.email]],
    });
    this.formGroup.controls['email'].valueChanges.subscribe(value => {
      this.onChanges();
    });
  }
  guardar() {

    this.api
      .postRequest<BaseHttpResponse<number>>("Utilizador/RecuperarPassword", this.formGroup.controls['email'].value)
      .then((data) => {
        if (data.ok)
          this.isLoadingResults = true;
        if (!data.ok)
          this.isLoadingError = true;
      })
      .catch((err) => {
      });
  }

  loginPage() {
    const route = "/login";
    this.router.navigate([route], { skipLocationChange: true });
  }
}
